import { useConfig } from "../context/config-context";

/**
 * AlertBanner - Bannière d'alerte positionnée en absolute sous le header
 *
 * @param {string} type - "success" | "warning" | "error"
 * @param {string|ReactNode} message - Message à afficher
 * @param {string} className - Classes CSS supplémentaires (optionnel)
 */
export default function AlertBanner({ type = "warning", message, className = "", onClose }) {
  const siteConfig = useConfig();

  // Dériver l'ecosystem depuis le chemin du logo (ex: "/diabete/logo.png" → "diabete")
  const ecosystem = siteConfig?.medias?.logo?.path?.split("/")?.[1] || "diabete";

  const STYLES = {
    warning: {
      bg: "#F5D9BE",
      border: "#E19843",
      iconPath: `/${ecosystem}/icons/warning.png`,
    },
    success: {
      bg: "#D4EED0",
      border: "#9EC797",
      iconPath: `/${ecosystem}/icons/success.png`,
    },
    error: {
      bg: "#F5C4CD",
      border: "#BC606B",
      iconPath: `/${ecosystem}/icons/error.png`,
    },
  };

  const style = STYLES[type] || STYLES.warning;

  return (
    <div
      className={`flex items-center gap-3 px-4 py-3 w-full text-sm ${className}`}
      style={{
        backgroundColor: style.bg,
        border: `1px solid ${style.border}`,
        borderRadius: "4px",
      }}
      role="alert"
    >
      <img
        src={style.iconPath}
        alt={type}
        className="flex-shrink-0 w-4 h-4 object-contain"
      />
      <span className="flex-1">{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          className="flex-shrink-0 text-current opacity-60 hover:opacity-100 transition-opacity ml-2 text-lg leading-none"
          aria-label="Fermer"
        >
          ×
        </button>
      )}
    </div>
  );
}
